export const rideWebhook = {
  payload: `{
  "Booking_id": "BK1234567890",
  "display_book_id": "W-1001",
  "status": "ACCEPT",
  "amount": "GBP 12.500",
  "customer_info": [
    {
      "name": "John Doe",
      "country_code": "+44",
      "phone": "7123456789",
      "email": "john@example.com"
    }
  ],
  "pick_info": {
    "lat": "51.5074",
    "long": "-0.1278",
    "address": "Pickup address here"
  },
  "drop_info": {
    "lat": "51.5155",
    "long": "-0.0922",
    "address": "Drop address here"
  },
  "order_details": "Leave at reception",
  "order_number": "ORD-7788",
  "driver_info": [
    {
      "name": "Driver Name",
      "country_code": "+44",
      "phone": "7987654321",
      "email": "driver@example.com",
      "location": {
        "latitude": 51.5090,
        "longitude": -0.1200
      }
    }
  ],
  "vehicle_info": [
    {
      "car": "Saloon",
      "model": "Prius",
      "brand": "Toyota",
      "color": "Black",
      "license_plate": "AB12 CDE"
    }
  ],
  "completed_timeline": [
    {
      "create_date_time": "2026-07-16 10:00:00",
      "assign_date_time": "2026-07-16 10:01:00",
      "pickup_date_time": "",
      "accept_date_time": "2026-07-16 10:02:00",
      "arrive_date_time": "",
      "begin_date_time": "",
      "drop_date_time": "",
      "complete_date_time": "",
      "cancel_date_time": ""
    }
  ]
}`,
  payloadFields: [
    { field: "Booking_id", type: "string", desc: "Internal booking ID" },
    { field: "display_book_id", type: "string", desc: "Display / reference booking ID" },
    { field: "status", type: "string", desc: "Current booking status (see status values)" },
    { field: "amount", type: "string", desc: "Amount with currency (e.g. GBP 12.500)" },
    { field: "customer_info", type: "array", desc: "Customer name, phone, email" },
    { field: "pick_info", type: "object", desc: "Pickup lat/long/address" },
    { field: "drop_info", type: "object", desc: "Drop lat/long/address" },
    { field: "order_details", type: "string", desc: "Order comment / notes" },
    { field: "order_number", type: "string", desc: "External order number (if any)" },
    { field: "driver_info", type: "array", desc: "Driver details + live location (when available)" },
    { field: "vehicle_info", type: "array", desc: "Vehicle type/model/brand/color/plate" },
    { field: "completed_timeline", type: "array", desc: "Booking timeline timestamps" },
  ],
  statusValues: [
    { status: "SEARCHING", meaning: "Looking for a driver" },
    { status: "ASSIGN", meaning: "Driver assigned" },
    { status: "ACCEPT", meaning: "Driver accepted" },
    { status: "UNASSIGN", meaning: "Driver unassigned" },
    { status: "ARRIVED AT CUSTOMER", meaning: "Driver arrived at pickup" },
    { status: "ONROUTE", meaning: "Trip started / on route" },
    { status: "ARRIVED AT DROP", meaning: "Arrived at drop location" },
    { status: "COMPLETED", meaning: "Trip completed & paid" },
    { status: "CANCELLED", meaning: "Booking cancelled" },
  ],
  credentials: [
    { item: "callback_url", desc: "Your webhook endpoint URL (registered in corporate credentials)" },
    { item: "webhook_secure_key", desc: "Shared secret used to sign/verify the payload" },
    { item: "Signature header", desc: "Usually x-secure-signature (confirm with Wiyak support if unsure)" },
  ],
};
